const listAttributes = [
  'subject',
  'videoId',
  'topic',
  'youtubeId',
  'topicResources',
  'title',
  'description',
  'creationDatetime',
  'resources',
  'topicVideos',
  'relatedVideos',
  'pathLabels',
  'host',
] as const;

const getAttributes = [...listAttributes] as const;

const searchAttributes = ['title'] as const;

const updateAttributes = [
  'title',
  'description',
  'host',
  'youtubeId',
  'relatedVideos',
  'resources',
] as const;

export const VideoAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Search: searchAttributes,
  Update: updateAttributes,
};
